import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import api from "../api";

import Collection from "../components/Collection";
import Loader from "../components/Loader";
import notify from "../components/Notification/helper";
import PageHeader from "../components/PageHeader";
import Cuisine from "../layouts/Cuisine";
import Cuisines from "../layouts/Cuisines";

import { getTranslation } from "../utils/translate";
import { useUpdateDocumentMeta } from "../hooks/useUpdateDocumentMeta";

function CollectionPage() {
  const { collectionId } = useParams();
  const language = useSelector(state => state.language);
  
  const [collection, setCollection] = useState({});
  const [loading, setLoading] = useState(false);
  const [beefCuts, setBeefCuts] = useState([]);
  const [cuisines, setCuisines] = useState([]);
  const [recipes, setRecipes] = useState([]);
  const [recipeAuthors, setRecipeAuthors] = useState([]);
  
  const apiFieldsToFetch = [
    'icon',
    'id',
    'items.collection',
    'items.id',
    'items.item.*',
    'items.sort',
    'items.item:beef_product.*',
    'items.item:beef_product.translations.*',
    'items.item:beef_product.beef_product_overrides.id',
    'items.item:beef_product.beef_product_overrides.destination',
    'items.item:beef_product.beef_product_overrides.retailer',
    'items.item:beef_product.beef_product_overrides.status',
    'items.item:beef_product.beef_product_overrides.translations.*',
    'items.item:collections.*',
    'items.item:collections.translations.*',
    'items.item:recipe.category.status',
    'items.item:recipe.category.translations.*',
    'items.item:recipe.retailers.retailer_id',
    'items.item:recipe.retailers.sort',
    'items.item:recipe.items.*',
    'items.item:recipe.imagegallery.*',
    'items.item:recipe.layout_translations.*',
    'items.item:recipe_author.*',
    'items.item:recipe_author.translations.*',
    'sort',
    'translations.*',
    'type',
  ];

  useUpdateDocumentMeta();

  useEffect(async() => {
    try {
      window.scrollTo(0, 0);
      setLoading(true);

      const getCollectionResponse = await api.getCollection(collectionId, apiFieldsToFetch);
      setCollection(getCollectionResponse);

      setBeefCuts(getCollectionResponse.items
        ?.filter(junction => junction.collection === 'beef_product')
        ?.map(junction => junction.item)
      )
      
      setCuisines(getCollectionResponse.items
        ?.filter(junction => junction.collection === 'collections')
        ?.map(junction => junction.item)
      );

      setRecipes(getCollectionResponse.items
        ?.filter(junction => junction.collection === 'recipe')
        ?.map(junction => junction.item)
      );

      setRecipeAuthors(getCollectionResponse.items
        ?.filter(junction => junction.collection === 'recipe_author')
        ?.map(junction => junction.item)
        ?.filter(individual => individual.status === 'published')
      );

      console.log('getCollectionResponse', getCollectionResponse);
      console.log('beefCuts', beefCuts);
      console.log('cuisines', cuisines);
      console.log('recipes', recipes);
      console.log('recipeAuthors', recipeAuthors);
    } catch(error) {
      error?.map((err) => notify('error', err.message));
    } finally {
      setLoading(false);
    }
  }, [collectionId]);

  if (loading) {
    return <Loader />
  }

  let content = null;

  switch(collection.type) {
    case 'CUISINE':
      content = (
        <Cuisine
          title={
            getTranslation(
              collection,
              {
                key: 'languages_code',
                code: language.code
              }
            ).title
          }
          description={
            getTranslation(
              collection,
              {
                key: 'languages_code',
                code: language.code
              }
            ).content
          }
          recipeAuthors={recipeAuthors}
          beefCuts={beefCuts}
          recipes={recipes}
          imageUrl={getTranslation(collection, { key: 'languages_code', code: language.code }).image ? `${process.env.REACT_APP_API_URL}/assets/${getTranslation(collection, { key: 'languages_code', code: language.code }).image}?key=page-hero-image` : null}
        />
      );
      break;
    case 'CUISINES':
      content = (
        <Cuisines
          title={
            getTranslation(
              collection,
              {
                key: 'languages_code',
                code: language.code
              }
            ).title
          }
          description={
            getTranslation(
              collection,
              {
                key: 'languages_code',
                code: language.code
              }
            ).content
          }
          cuisines={cuisines}
          imageUrl={`${process.env.REACT_APP_API_URL}/assets/${getTranslation(collection, { key: 'languages_code', code: language.code }).image}?key=page-hero-image`}
        />
      );
      break;
    default:
      content = (
        <Collection
          id={collectionId}
          content
        />
      );
      break;
  }
  
  return (
    <Box
      className="collection"
    >
      <Container maxWidth disableGutters
        sx={{ p: 0 }}
      >
        <Box>
          <PageHeader item={{ 
            name: getTranslation(collection, { key: 'languages_code', code: language.code }).title,
            recipe: [],
            svg_icon: collection.icon
          }}
          useAsLink={false}
        />
        </Box>
      </Container>

      <Container
        sx={{
          my: 5
        }}
      >
        {content}
      </Container>
    </Box>
  )
}

export default CollectionPage